"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrencyFormat = void 0;
var apps_shared_1 = require("@l2p/apps-shared");
var react_1 = require("react");
var useCurrentCurrency_1 = require("./useCurrentCurrency");
var CurrencyTypeFormat;
(function (CurrencyTypeFormat) {
    CurrencyTypeFormat["SYMBOL"] = "symbol";
    CurrencyTypeFormat["CURRENCY"] = "currency";
})(CurrencyTypeFormat || (CurrencyTypeFormat = {}));
var useCurrencyFormat = function () {
    var currencyForConverter = (0, useCurrentCurrency_1.useCurrentCurrency)();
    return (0, react_1.useCallback)(function (baseValue, type) {
        var _a;
        if (type === void 0) { type = CurrencyTypeFormat.CURRENCY; }
        if (!baseValue)
            return '';
        if (type === CurrencyTypeFormat.SYMBOL)
            return "".concat((0, apps_shared_1.getCurrencySymbol)(currencyForConverter), " ").concat((_a = (Number(baseValue) || 0)) === null || _a === void 0 ? void 0 : _a.toFixed(2));
        return "".concat(baseValue, " ").concat(currencyForConverter);
    }, [currencyForConverter]);
};
exports.useCurrencyFormat = useCurrencyFormat;
